var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommissionsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 20.125C16.5 20.125 17.75 20.125 19 22.625C19 22.625 22.9712 16.375 26.5 15.125M5.875 11.375H5.86375M12.75 21.375H12.125C7.42625 21.375 5.0775 21.375 3.50875 20.1375C3.25945 19.94 3.02775 19.7213 2.81625 19.4837C1.5 18.0087 1.5 15.7962 1.5 11.375C1.5 6.95375 1.5 4.7425 2.81625 3.26625C3.02708 3.02958 3.25792 2.81208 3.50875 2.61375C5.0775 1.375 7.42625 1.375 12.125 1.375H15.875C20.5737 1.375 22.9225 1.375 24.49 2.6125C24.7417 2.8125 24.9729 3.03042 25.1837 3.26625C26.37 4.59625 26.4875 6.5225 26.5 10.125V10.75",
    stroke: "#243142",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.125 11.375C17.125 12.2038 16.7958 12.9987 16.2097 13.5847C15.6237 14.1708 14.8288 14.5 14 14.5C13.1712 14.5 12.3763 14.1708 11.7903 13.5847C11.2042 12.9987 10.875 12.2038 10.875 11.375C10.875 10.5462 11.2042 9.75134 11.7903 9.16529C12.3763 8.57924 13.1712 8.25 14 8.25C14.8288 8.25 15.6237 8.57924 16.2097 9.16529C16.7958 9.75134 17.125 10.5462 17.125 11.375Z",
    stroke: "#243142",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommissionsIcon);
export default __webpack_public_path__ + "static/media/commissionsIcon.4b09ec2f87f73b11c576ed84ea9a9fdf.svg";
export { ForwardRef as ReactComponent };